export const TitleText = ({ children }: { children: React.ReactNode }) => {
    return <span className="text-body fw-bold text-wrap text-break">{children}</span>;
};
